export default "__VITE_ASSET__mPMfnMv___"